<template>
  <div class="doc" :model='paras' v-html="fill_all(paras)">
  </div>
</template>

<script>
var x=""
var title_level=1
var title_name=''
var pid=''

function fill_outline_s1(msg,pid){
    title_level+=1
    x+='<ul>'
    var c=0
    // var tlv2='</h'+title_level+'>'
    for(var h1 in msg){
        c+=1
        var id_name=pid+"."+c
        if(pid==''){
            id_name=c
        }
        var tlv1='<li><a href="#'+id_name+'">'
        x+=tlv1+id_name+'&nbsp;&nbsp;'+h1+'</a></li>'
        if (!(msg[h1] instanceof Array)){
            fill_outline_s1(msg[h1],c)
        }
    }
    return x
}

function fill_context_s1(msg,pid){
    var c=0
    title_level+=1

    for(var h1 in msg){
        c+=1
        var id_name=pid+"."+c
        if(pid==''){
            id_name=c
        }
        // var tlv1='<a href="#'+id_name+'"><li>'
        var tlv1='<h'+title_level+' name="'+id_name+'">'
        var tlv2='</h'+title_level+'>'
        x+=tlv1+h1+tlv2 
        if (msg[h1] instanceof Array){
            for (var i in msg[h1]){
                x+='<p>'+msg[h1][i]+'</p>'
            }
        }else{
            fill_context_s1(msg[h1],c)
        }
    }
    return x
}


function fill_context(msg){
    x=""
    title_level=1
    pid=''
    return fill_context_s1(msg,pid);
}

function fill_outline(msg){
    x=''
    pid=''
    title_level=1
    var oulititle='<h2>Outline</h2>'
    return oulititle+fill_outline_s1(msg,pid)
}

export default {
    props:['paras'],
    name: 'Doc',
    methods:{
        fill_all:function(paras){
            var out_v="<div class='outline'>"
            +fill_outline(paras.msg)
            +"</div>"
            var con_v="<div class='context'>"
            +fill_context(paras.msg)
            +"</div>"
            if (paras.has_outline) {
                return out_v+con_v
            }
            return con_v
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.doc {
    /* width: 100%; */
    margin:30px 40px 10px 40px;
    padding: 0;
    display: inline-block;
}
.outline {
    width: 300px;
    display: block;
    float: left;
    margin-right: 100px;
    margin-top: 50px;
    /* position: absolute; */
    /* background: white; */
}

.outline ul {
    list-style: none;
    text-align: left;
    padding: 0;
    margin-left: 50px;
    /* background: #428bca; */
}

.outline ul a{
    color :#006652;
}

.outline h2{
    margin-left: 40px;
    text-align: left;

}

.context {
    /* display: inline-block ; */
    /* float: right; */
    /* width: 500px; */
    /* width: 100%; */
    text-align: left;
    float: left;

}
.context h1,h2,h3,h4,h5 {
    color:#006652;
}

.context p {
    color: #000000;
    line-height: 15px;
    font-size: 15px;
    margin:5px 0px;
}

.context h2{
    font-size: 20px;
    line-height: 20px;
    margin:15px 0px;
}

.context a{
    color:#006652;
}

</style>



// WEBPACK FOOTER //
// src/components/doc.vue